module.exports = __webpack_public_path__ + "static/media/my-data.b62c5317.svg";